import { COUNTRIES, DELIVERY_METHODS } from "@/lib/delivery"

const input = "mt-1.5 w-full rounded-xl border border-brand-green/20 bg-brand-navy px-4 py-3 text-sm text-brand-light placeholder:text-brand-muted/60 focus:border-brand-green focus:outline-none"

const Field = ({ label, k, d, set, placeholder, className = "" }) => (
  <label className={`block text-xs text-brand-muted ${className}`}>{label}
    <input value={d[k]} onChange={(e) => set({ ...d, [k]: e.target.value })} placeholder={placeholder} data-testid={`delivery-${k.replace("_", "-")}-input`} className={input} />
  </label>
)

export function DeliveryForm({ value: d, onChange: set }) {
  const pickup = d.method === "pickup"
  const ug = d.country === "UG"
  const choose = (m) => set({ ...d, method: m.id, country: m.country || d.country, region: m.id === "mn_free" ? "MN" : d.region })
  return (
    <div className="rounded-2xl border border-brand-green/15 bg-brand-mid p-6" data-testid="delivery-form">
      <h2 className="font-display text-3xl font-black text-brand-light">DELIVERY</h2>
      <p className="mt-1 text-sm text-brand-muted">Choose how you'd like to receive your order. We'll call you to schedule.</p>
      <div className="mt-5 grid gap-3 sm:grid-cols-2" role="radiogroup">
        {DELIVERY_METHODS.map((m) => (
          <button type="button" key={m.id} role="radio" aria-checked={d.method === m.id} onClick={() => choose(m)} data-testid={`delivery-method-${m.id}`}
            className={`rounded-xl border p-4 text-left transition-colors ${d.method === m.id ? "border-brand-green bg-brand-green/15" : "border-brand-green/20 hover:border-brand-green/50"}`}>
            <div className="flex items-start justify-between gap-3">
              <span className="text-sm font-bold text-brand-light">{m.label}</span>
              <span className="whitespace-nowrap text-sm font-black text-brand-green-light">{m.fee ? `$${m.fee}` : "FREE"}</span>
            </div>
            <div className="mt-1 text-xs text-brand-muted">{m.hint}</div>
          </button>
        ))}
      </div>
      <div className="mt-6 grid gap-4 sm:grid-cols-2">
        <Field label="Full name *" k="full_name" d={d} set={set} placeholder="Jane Doe" />
        <Field label="Phone *" k="phone" d={d} set={set} placeholder="+256 7XX XXX XXX" />
        {!pickup && <>
          <Field label="Street address / landmark *" k="address" d={d} set={set} placeholder="Plot 12, Kampala Road, near…" className="sm:col-span-2" />
          <Field label={ug ? "City / district *" : "City *"} k="city" d={d} set={set} placeholder={ug ? "Kampala" : "Eden Prairie"} />
          <Field label={ug ? "Region" : "State / province *"} k="region" d={d} set={set} placeholder={ug ? "Central" : "MN"} />
          <Field label={ug ? "Postal code (optional)" : "ZIP / postal code *"} k="postal_code" d={d} set={set} placeholder={ug ? "" : "55344"} />
          <label className="block text-xs text-brand-muted">Country *
            <select value={d.country} onChange={(e) => set({ ...d, country: e.target.value })} data-testid="delivery-country-select" className={input}>
              <option value="">Select country</option>
              {COUNTRIES.map(([c, n]) => <option key={c} value={c}>{n}</option>)}
            </select>
          </label>
        </>}
        <label className="block text-xs text-brand-muted sm:col-span-2">Delivery notes
          <textarea value={d.notes} onChange={(e) => set({ ...d, notes: e.target.value })} rows={2} placeholder="Gate code, office floor, best time to call…" data-testid="delivery-notes-input" className={input} />
        </label>
      </div>
    </div>
  )
}
